import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorComponent } from '../../../../../osp-ui/components/form/form-field/components/error/error.component';
import { LabelComponent } from '../../../../../osp-ui/components/form/form-field/components/label/label.component';
import { FormFieldComponent } from '../../../../../osp-ui/components/form/form-field/form-field.component';
import { InputNumberComponent } from '../../../../../osp-ui/components/form/input-number/input-number.component';
import { AlarmSettingsFieldData } from '../../../contract/alarm-settings-field-data.contract';
import { AlarmSettingsUtilsService } from '../../../services/alarm-settings-utils.service';
import { AlarmSettingsBase } from '../alarm-settings-base.class';
import { AlarmSettingsFormControls } from '../contract/alarm-settings-form-controls.contract';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    InputNumberComponent,
    FormFieldComponent,
    LabelComponent,
    ErrorComponent,
  ],
  selector: 'osp-limit-settings',
  templateUrl: './limit-settings.component.html',
})
export class LimitSettingsComponent extends AlarmSettingsBase implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() set form(form: FormGroup<AlarmSettingsFormControls>) {
    this.settingsForm = form;
  }

  @Input() set fieldData(fieldData: AlarmSettingsFieldData) {
    this.alarmSettingsFieldData = fieldData;
  }

  protected settingsLimitExplanation: string = '';
  protected settingsIntervalExplanation: string = '';
  protected settingsLimitLabel = '';
  protected settingsIntervalLabel = '';
  protected isIntervalFieldVisible = true;

  constructor(private alarmSettingsUtilsService: AlarmSettingsUtilsService) {
    super();
  }

  public ngOnInit(): void {
    this.subscribeToAlarmTypeChanges();
    this.setExplanations();
    this.setLabels();
  }

  public get inputMaxFractionDigits(): number | null {
    return this.alarmSettingsUtilsService.getInputMaxFractionDigits();
  }

  private subscribeToAlarmTypeChanges(): void {
    this.alarmSettingsUtilsService.alarmTypeChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isIntervalFieldVisible = this.alarmSettingsUtilsService.isControlRequired(
        this.controlNames.SETTINGS_INTERVAL,
      );
    });
  }

  private setExplanations(): void {
    this.settingsLimitExplanation = this.getFieldTooltipText(this.controlNames.SETTINGS_LIMIT);
    this.settingsIntervalExplanation = this.getFieldTooltipText(this.controlNames.SETTINGS_LIMIT);
  }

  private setLabels(): void {
    this.settingsLimitLabel = this.getFieldLabel(this.controlNames.SETTINGS_LIMIT);
    this.settingsIntervalLabel = this.getFieldLabel(this.controlNames.SETTINGS_INTERVAL);
  }
}
